import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { UserTrailActionTypes } from '../enums/user-trail-action-types.enum';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';

export class RegisterUserTrailCommand
    extends IRequestCommand<
    ICommandResponse,
    ErrorDetails,
    IRegisterUserTrailCommandRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.POST;

    public override setParameters(parameters: IRegisterUserTrailCommandRequest) {
        this._commandBody = parameters;
        this.urlSections.push('usertrail');
        this.urlSections.push('register');
        this.composeUrl();
    }
}

export interface IRegisterUserTrailCommandRequest extends ICommandParameters  {
  carrierId: number;
  userId: number;
  actionCode: string;
  actionType: UserTrailActionTypes;
  businessData: string|null;
}

export interface IRegisterUserTrailCommandResponse extends ICommandResponse {

}
